const FORM_MODE = {
  INSERT: 1,
  UPDATE: 2,
};
export default FORM_MODE;
